export default __webpack_public_path__ + "static/19-eaa9e6b01dbdcc148a2a76b51513a37d.png";